export default __webpack_public_path__ + "static/10-b05915caeca0c42cac4942eae93cdbec.jpg";